import React from 'react';
import './attendee-group-column.scss';
import { IAttendeeDTO } from '../../../api/attendees.dao';
import DefaultButton from '../../global/default-button/default-button';
import Text from '../text/text';

const AttendeeGroupColumn = (
    props: {
        attendees: IAttendeeDTO[];
        onEdit: (attendeeId) => void;
        searchValue: string;
        isEditable: boolean;
    }) => {

    const {
        attendees,
        onEdit,
        searchValue,
        isEditable
    } = props;

    return (
        <>
            {
                attendees
                    .slice()
                    .sort((a, b) => a.lastName.localeCompare(b.lastName))
                    .map(({ attendeeId, firstName, lastName, title }) => {
                        const attendeeInfo = firstName + ' ' + lastName + `${!!title ? ', ' + title : ''}`;

                        return (
                            <div
                                key={attendeeId}
                                className='attendee-list-item attendee-group-column'
                                onDoubleClick={() => isEditable && onEdit(attendeeId)}
                            >
                                <Text
                                    tag='div'
                                    className='attendee-list-item__text'
                                    message={attendeeInfo}
                                    highlightValue={searchValue}
                                    withEllipsis
                                    withHighlight
                                />
                                { isEditable && (
                                    <DefaultButton
                                        className='edit-attendee-button'
                                        modifier='slim'
                                        text='Edit'
                                        onClick={() => onEdit(attendeeId)}
                                    />
                                )}
                            </div>
                        );
                    })
            }
        </>

    );
};

export { AttendeeGroupColumn };